import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { request } from 'js/api/axios';
import CreateRubricComponent from '../components/CreateRubricComponent';

function CreateRubricContainer({ token }) {
  const { workspaceId } = useParams();
  const history = useHistory();

  const handleSave = useCallback(
    ({ name, document }) => {
      return request
        .post(
          `/api/workspaces/${workspaceId}/rubrics`,
          { rubric: { name, document } },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          const rubricId = res?.data?.data?.id;
          if (!rubricId) {
            history.push(`/w/${workspaceId}/rubrics`);
            return;
          }
          history.push(
            `/w/${workspaceId}/rubrics/${encodeURIComponent(rubricId)}`
          );
        });
    },
    [token, workspaceId, history]
  );

  return (
    <CreateRubricComponent workspaceId={workspaceId} onSave={handleSave} />
  );
}

export default connect((state) => ({
  token: state.identity.token,
}))(CreateRubricContainer);
